import type { WorksheetSubmissionGroupEntity } from '../entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { isSuccessResponse, normalizeCaseDetailsResponse } from '../../cases/helpers';
import { toWorksheetSubmissionGroupEntity } from '../helpers';

/** Parameters for fetching worksheet submission groups. */
export type FetchGroupsParams = {
    /** The case number to fetch worksheet groups for. */
    caseNumber: string;
};

/**
 * Fetch case details from NorthStar and extract the WorksheetSubmissionGroups.
 * Used after returning from the worksheet editor to get the latest submission
 * data without a full page reload.
 */
export class FetchGroups extends StsBackendOperation {
    /**
     * Fetch case details and extract the WorksheetSubmissionGroups array as domain entities.
     *
     * @param params - the case number to fetch worksheet groups for
     * @returns the worksheet submission group entities, or undefined if the fetch fails
     */
    async exec(params: FetchGroupsParams): Promise<WorksheetSubmissionGroupEntity[] | undefined> {
        const { caseNumber } = params;
        const response = await this.client.getCaseDetails({ caseNumber });

        if (!isSuccessResponse(response)) {
            return undefined;
        }

        // Extract and normalize the case details to get worksheet submission groups
        const retailerData = normalizeCaseDetailsResponse(response.data.caseDetails);
        const groups = retailerData?.WorksheetSubmissionGroups;

        return groups?.map(toWorksheetSubmissionGroupEntity);
    }
}
